// German for the roadmap — the timeline, the workbenches, the fold rail, the bench's agent chat.
// Statuses, priorities and the actors (agent/operator) come from the shared vocabulary.
import { registerDe } from '../../i18n/index.js';

registerDe({
  // ── the editor hint and the months ──
  'saves when you leave the field · **fett** · *kursiv* · „- “ für Listen · # inserts a reference':
    'wird beim Verlassen des Felds gespeichert · **fett** · *kursiv* · «- » für Listen · # fügt eine Referenz ein',
  'Jan': 'Jan', 'Feb': 'Feb', 'Mar': 'März', 'Apr': 'Apr', 'May': 'Mai', 'Jun': 'Juni',
  'Jul': 'Juli', 'Aug': 'Aug', 'Sep': 'Sept', 'Oct': 'Okt', 'Nov': 'Nov', 'Dec': 'Dez',

  // ── refusals and outages ──
  'The items did not load.': 'Die Inhaltselemente wurden nicht geladen.',
  'The change was refused.': 'Die Änderung wurde abgelehnt.',
  'The item was refused.': 'Das Inhaltselement wurde abgelehnt.',
  'The agent did not answer.': 'Der Agent hat nicht geantwortet.',
  'The hold was refused.': 'Die Übernahme wurde abgelehnt.',
  'The transcript did not load.': 'Das Transkript wurde nicht geladen.',
  '#{id} held — it landed in Contents': '#{id} übernommen — es liegt jetzt unter Inhalt',

  // ── the bench head ──
  'Workbench {ref}': 'Werkbank {ref}',
  '{ref} renamed': '{ref} umbenannt',
  'Edit the name': 'Namen bearbeiten',
  'due {date}': 'fällig {date}',
  'Previous deliverable in this bench': 'Vorheriges Arbeitsergebnis in dieser Werkbank',
  'Next deliverable in this bench': 'Nächstes Arbeitsergebnis in dieser Werkbank',
  'Close this bench': 'Diese Werkbank schliessen',

  // ── description / definition of done ──
  'Description': 'Beschreibung',
  'Edit the description': 'Beschreibung bearbeiten',
  'What this deliverable is.': 'Was dieses Arbeitsergebnis ist.',
  '{ref} description saved': '{ref} Beschreibung gespeichert',
  '— no description yet': '— noch keine Beschreibung',
  'Definition of done': 'Abnahmekriterien',
  'Edit the definition of done': 'Abnahmekriterien bearbeiten',
  'The observable condition under which this is finished.': 'Die beobachtbare Bedingung, unter der dies fertig ist.',
  '{ref} definition of done saved': '{ref} Abnahmekriterien gespeichert',
  '— not defined yet': '— noch nicht definiert',

  // ── the content items ──
  'Contents': 'Inhalt',
  'sorted by date · ◇ drafted · ▪ held': 'nach Datum sortiert · ◇ Entwurf · ▪ übernommen',
  'Edit the title': 'Titel bearbeiten',
  'undated': 'ohne Datum',
  'Move up': 'Nach oben',
  'Move down': 'Nach unten',
  'Specify this piece — what it contains, how it is judged…': 'Dieses Element spezifizieren — was es enthält, wie es beurteilt wird…',
  '— no specification yet': '— noch keine Spezifikation',
  'Edit the specification': 'Spezifikation bearbeiten',
  'Due': 'Fällig',
  'changing the date re-sorts the list': 'eine Datumsänderung sortiert die Liste neu',
  'Satisfies': 'Erfüllt',
  'which of this deliverable’s requirements the piece serves': 'welchen Anforderungen dieses Arbeitsergebnisses das Element dient',
  'Documents': 'Dokumente',
  'Detach': 'Lösen',
  '+ Attach…': '+ Anhängen…',
  'Provenance': 'Herkunft',
  'Hold ▪': 'Übernehmen ▪',
  'Back to draft ◇': 'Zurück zum Entwurf ◇',
  'Drop': 'Verwerfen',
  'No content items yet — add one below, or ask the agent.': 'Noch keine Inhaltselemente — unten eines hinzufügen oder den Agenten fragen.',
  'Add a content item by hand…': 'Inhaltselement von Hand hinzufügen…',
  'Add': 'Hinzufügen',

  // ── refine with the agent ──
  'Refine with the agent': 'Mit dem Agenten verfeinern',
  // the chat panel: the fold, the switcher, the composer
  'Fold the chat in': 'Chat einklappen',
  'Fold the chat out': 'Chat ausklappen',
  'Conversations': 'Gespräche',
  'New conversation': 'Neues Gespräch',
  'Close the conversation list': 'Gesprächsliste schliessen',
  'Jump to the latest': 'Zum Neusten springen',
  'Enter sends · Shift+Enter starts a new line': 'Enter sendet · Shift+Enter fügt eine neue Zeile ein',
  'this deliverable': 'dieses Arbeitsergebnis',
  'all conversations': 'alle Gespräche',
  'run #{id}': 'Lauf #{id}',
  'A conversation scoped to {ref} — it stays here when you close the bench, and lands in “all conversations” for good.': 'Ein Gespräch zu {ref} — es bleibt hier, wenn Sie die Werkbank schliessen, und landet dauerhaft unter «alle Gespräche».',
  'agent · proposes into the queue, writes nothing': 'Agent · schlägt in die Warteschlange vor, schreibt nichts',
  'Hold': 'Übernehmen',
  '{status} · in the queue': '{status} · in der Warteschlange',
  'agent': 'Agent',
  'thinking…': 'denkt nach…',
  'Ask — e.g. "Break {name} down further"': 'Fragen — z. B. «Gliedere {name} feiner auf»',
  'Ask →': 'Fragen →',
  '← all conversations': '← alle Gespräche',
  'run #{id} · {date} · {status}': 'Lauf #{id} · {date} · {status}',
  'No transcript on record — a live run writes it when it ends.': 'Kein Transkript erfasst — ein laufender Lauf schreibt es, wenn er endet.',
  'reading the conversations…': 'Gespräche werden geladen…',
  'conversation': 'Gespräch',
  'No conversations in this engagement yet.': 'Noch keine Gespräche in diesem Auftrag.',
  'The agent proposes, you hold — held items land in Contents with their provenance; refusals keep their reason and teach the next run.': 'Der Agent schlägt vor, Sie übernehmen — übernommene Elemente landen mit ihrer Herkunft unter Inhalt; Ablehnungen behalten ihre Begründung und lehren den nächsten Lauf.',

  // ── the requirements aside ──
  '{n} requirement · a source ref opens the span': '{n} Anforderung · eine Quellenreferenz öffnet die Stelle',
  '{n} requirements · a source ref opens the span': '{n} Anforderungen · eine Quellenreferenz öffnet die Stelle',
  'Show the span {ref} cites in {doc}': 'Die Quellenstelle anzeigen, die {ref} in {doc} zitiert',

  // ── the board ──
  '{refs} folded to the right — the dock shows {n} at this width': '{refs} nach rechts eingeklappt — das Dock zeigt bei dieser Breite {n}',
  '{ref} → due {date}': '{ref} → fällig {date}',
  'The roadmap': 'Die Roadmap',
  'drag a card = re-date · pull an edge = stretch · grab the grid = pan · click = work out (click another = beside it)': 'Karte ziehen = umdatieren · Kante ziehen = strecken · Raster greifen = verschieben · Klick = ausarbeiten (weiterer Klick = daneben)',
  'Faint lines are weeks, stronger lines are months.': 'Feine Linien sind Wochen, kräftige Linien Monate.',
  'A drag writes {start} / {due} and an audit row.': 'Ein Ziehen schreibt {start} / {due} und eine Prüfpfad-Zeile.',
  'Undated deliverables wait in the tray until you date them — drag one onto the grid.': 'Arbeitsergebnisse ohne Datum warten in der Ablage, bis Sie sie datieren — ziehen Sie eines aufs Raster.',
  'Drag onto the roadmap to date it · click to work it out': 'Auf die Roadmap ziehen zum Datieren · Klick zum Ausarbeiten',
  '{ref} → undated — back in the tray': '{ref} → ohne Datum — zurück in der Ablage',
  '{ref} is dated on the record — switch to “As recorded” to pull it back.': '{ref} ist im Protokoll datiert — wechseln Sie zu «Wie festgehalten», um es zurückzuziehen.',
  'drop a card here to undate it': 'Karte hier ablegen, um ihr Datum zu entfernen',
  '{ref} pinned to its lane': '{ref} in seiner Spur fixiert',
  '{ref} unmapped — the requirement itself stays': '{ref} gelöst — die Anforderung selbst bleibt',
  'Referenced in': 'Referenziert in',
  'texts that name {ref} — change it and they may need to move along': 'Texte, die {ref} nennen — ändern Sie es, müssen sie eventuell mitziehen',
  'Unmap {ref} from this deliverable — the requirement itself stays': '{ref} von diesem Arbeitsergebnis lösen — die Anforderung selbst bleibt',
  'Workbenches': 'Werkbänke',
  'Folded benches': 'Eingeklappte Werkbänke',
  'Close {ref}': '{ref} schliessen',
  '{ref} · {name} — unfold': '{ref} · {name} — ausklappen',
  'Expand the roadmap to the full screen': 'Roadmap auf die volle Breite ausklappen',
  'Back to the page width': 'Zurück zur Seitenbreite',
  'all': 'alle',
  '+ New conversation': '+ Neues Gespräch',
  'No conversations here yet.': 'Noch keine Gespräche hier.',
  'A conversation scoped to {ref} — it is kept for good and comes back whenever you reopen the bench.': 'Ein Gespräch im Rahmen von {ref} – es bleibt dauerhaft erhalten und kehrt zurück, sooft Sie die Werkbank öffnen.',
  'in the queue': 'in der Warteschlange',

  // — merged in from the pencil-layer branch —
  'As recorded': 'Wie festgehalten',
  'With assumptions': 'Mit Annahmen',
  'Which roadmap you are looking at': 'Welche Roadmap Sie sehen',
  'The dates the engagement is held to — a drag writes them': 'Die Termine, an denen der Auftrag gemessen wird — ein Ziehen schreibt sie',
  'The plan: assumptions drawn where they are pencilled, the record left as a faint slot — a drag writes the assumption': 'Die Planung: Annahmen dort gezeichnet, wo sie geplant sind, das Festgehaltene bleibt als blasser Platz — ein Ziehen schreibt die Annahme',
  'drag a card = re-plan the assumption · the record does not move · click = work out': 'Karte ziehen = Annahme neu planen · das Festgehaltene bleibt · Klick = ausarbeiten',
  'Assumption': 'Annahme',
  'Assumption — waiting on {ref}: {question}': 'Annahme — wartet auf {ref}: {question}',
  '{ref} on the record: {date}': '{ref} festgehalten: {date}',
  '{ref} planned for {date} — assumption, waiting on {q}': '{ref} geplant auf {date} — Annahme, wartet auf {q}',
  '{ref} has no open question to hang an assumption on — tether one in the workbench first.': 'Für {ref} gibt es keine offene Frage, an die eine Annahme gehängt werden kann — hängen Sie sie zuerst in der Werkbank an.',
  'You are looking at the plan: a dashed card is an assumption, the faint slot behind it is what the engagement is held to. Settling its question on the client call reverts it or adopts it.': 'Sie sehen die Planung: Eine gestrichelte Karte ist eine Annahme, der blasse Platz dahinter ist das, woran der Auftrag gemessen wird. Wird ihre Frage im Kundengespräch entschieden, wird die Annahme verworfen oder übernommen.',
  'Assumptions are pencilled on this roadmap — switch to “With assumptions” to see them.': 'Auf dieser Roadmap sind Annahmen eingezeichnet — wechseln Sie auf «Mit Annahmen», um sie zu sehen.',
  'An assumption is planned in a workbench: pick a date, hang it on the open question that has to settle first.': 'Eine Annahme wird in einer Werkbank geplant: Datum wählen und an die offene Frage hängen, die zuerst entschieden werden muss.',
  'Dates': 'Termine',
  'Start': 'Beginn',
  'the record · an assumption is planned beside it, never over it': 'das Festgehaltene · eine Annahme wird daneben geplant, nie darüber',
  'as an assumption': 'als Annahme',
  'plan as an assumption': 'als Annahme planen',
  'Plan this date as an assumption, tethered to an open question — the record does not move': 'Dieses Datum als Annahme planen, an eine offene Frage gehängt — das Festgehaltene bleibt unverändert',
  'The open question this assumption waits on': 'Die offene Frage, auf die diese Annahme wartet',
  'The date you are assuming': 'Das angenommene Datum',
  'every other open question': 'alle übrigen offenen Fragen',
  'why, in one line — optional': 'warum — eine Zeile, optional',
  'Pencil it in': 'Als Annahme eintragen',
  'Cancel': 'Abbrechen',
  'Rub this assumption out — the record never moved': 'Diese Annahme verwerfen — das festgehaltene Datum hat sich nie bewegt',
  'Nothing open to hang an assumption on — a pencilled date has to say what it waits on.': 'Keine offene Frage vorhanden, an die eine Annahme gehängt werden kann — ein geplantes Datum muss sagen, worauf es wartet.',
  'The assumption was refused.': 'Die Annahme wurde abgelehnt.',
  'under clarification': 'in Klärung',
  'An open question names {ref} — this ground is not settled yet': 'Eine offene Frage nennt {ref} — dieser Boden ist noch nicht gesichert',
  'A drag writes an assumption over {start} / {due} — never the row itself.': 'Ein Ziehen schreibt eine Annahme über {start} / {due} — nie die Zeile selbst.',

  // ── the standing half of the pencil layer: PROVISIONAL (◈), and the pending queue (◇)
  // reaching the workbench ──
  'Provisional': 'Provisorisch',
  'Provisional — waiting on {ref}: {question}': 'Provisorisch — wartet auf {ref}: {question}',
  'Clear this mark — the record never moved': 'Diese Markierung löschen — das Festgehaltene hat sich nie bewegt',
  'mark provisional': 'als provisorisch markieren',
  'Mark provisional ◈': 'Als provisorisch markieren ◈',
  'The open question this mark waits on': 'Die offene Frage, auf die diese Markierung wartet',
  'The mark was refused.': 'Die Markierung wurde abgelehnt.',
  'Nothing open to tether a provisional mark to — mark one only once a question is open to settle it.':
    'Keine offene Frage vorhanden, an die sich eine provisorische Markierung hängen liesse — erst markieren, wenn eine Frage offen ist, die darüber entscheidet.',
  'Mark this deliverable provisional, tethered to an open question — a standing override, not the record itself':
    'Dieses Arbeitsergebnis als provisorisch markieren, an eine offene Frage gehängt — ein Statusvorbehalt, nicht das Festgehaltene selbst',
  'Mark {ref} provisional, tethered to an open question — a standing override, not the record itself':
    '{ref} als provisorisch markieren, an eine offene Frage gehängt — ein Statusvorbehalt, nicht das Festgehaltene selbst',
  'Untreated': 'Unbehandelt',
  '◇ said by the agent, not yet judged': '◇ vom Agenten gesagt, noch nicht beurteilt',
  '{n} untreated': '{n} unbehandelt',
  '{n} proposal from the agent is still waiting on a Hold or a decision': '{n} Vorschlag des Agenten wartet noch auf Übernahme oder Entscheid',
  '{n} proposals from the agent are still waiting on a Hold or a decision': '{n} Vorschläge des Agenten warten noch auf Übernahme oder Entscheid',
  'untreated': 'unbehandelt',
  '#{id} held — the mark is set': '#{id} übernommen — die Markierung ist gesetzt',
  'a provisional mark': 'eine provisorische Markierung',
  'The agent has proposed a provisional mark here — not yet judged': 'Der Agent hat hier eine provisorische Markierung vorgeschlagen — noch nicht beurteilt',
  'The agent has proposed provisional marks here — not yet judged': 'Der Agent hat hier provisorische Markierungen vorgeschlagen — noch nicht beurteilt',

  // ── the dependency linker ──
  'Linked': 'Verknüpft',
  'builds on · when the linked content changes, this side is flagged': 'baut auf · ändert sich der verknüpfte Inhalt, wird diese Seite markiert',
  '+ Link…': '+ Verknüpfen…',
  'builds on': 'baut auf',
  'builds on this': 'baut hierauf',
  'builds on {ref}': 'baut auf {ref}',
  'The deliverable this one builds on': 'Das Arbeitsergebnis, auf dem dieses aufbaut',
  'pick a deliverable…': 'Arbeitsergebnis wählen…',
  'Pin this side to one of its content items — optional': 'Diese Seite an eines ihrer Inhaltselemente heften — optional',
  'this whole deliverable': 'dieses ganze Arbeitsergebnis',
  'Pin the other side to one of its content items — optional': 'Die andere Seite an eines ihrer Inhaltselemente heften — optional',
  'their whole deliverable': 'deren ganzes Arbeitsergebnis',
  'Link': 'Verknüpfen',
  'The link was refused.': 'Die Verknüpfung wurde abgelehnt.',
  'Open the {ref} bench beside this one': 'Die Werkbank {ref} neben dieser öffnen',
  'via {ref}': 'über {ref}',
  'Recorded when a cross-deliverable proposal was held': 'Festgehalten, als ein Arbeitsergebnis-übergreifender Vorschlag übernommen wurde',
  'The linked content changed after this deliverable last reconciled with it': 'Der verknüpfte Inhalt hat sich geändert, seit dieses Arbeitsergebnis zuletzt damit abgeglichen wurde',
  'linked content changed': 'verknüpfter Inhalt geändert',
  'Adapt with the agent': 'Mit dem Agenten anpassen',
  'Mark it reconciled — nothing needed adapting': 'Als abgeglichen markieren — nichts musste angepasst werden',
  'Reconciled ✓': 'Abgeglichen ✓',
  'Remove this link': 'Diese Verknüpfung entfernen',
  '— nothing linked yet · a link says whose content this deliverable builds on': '— noch nichts verknüpft · eine Verknüpfung sagt, auf wessen Inhalt dieses Arbeitsergebnis aufbaut',
  'Content this deliverable builds on has changed — open the bench to reconcile': 'Inhalt, auf dem dieses Arbeitsergebnis aufbaut, hat sich geändert — Werkbank öffnen und abgleichen',
  'This proposal lands in {ref} — it appears in that bench and in the review queue': 'Dieser Vorschlag landet in {ref} — er erscheint in jener Werkbank und in der Warteschlange',
  'Proposed from the {ref} workbench — its refinement needs something here': 'Aus der Werkbank {ref} vorgeschlagen — deren Ausarbeitung braucht hier etwas',
  'Proposed by the roadmap planner — it judged the plan as a whole': 'Vom Roadmap-Planer vorgeschlagen — er hat den Plan als Ganzes beurteilt',
  'from the planner': 'vom Planer',
  'from {ref}': 'aus {ref}',
  '#{id} held — the amendment is applied': '#{id} übernommen — die Änderung ist angewendet',
  '#{id} held': '#{id} übernommen',
  '{ref} — the content this deliverable builds on in {other} has changed. Compare against {other} and propose adaptations to my content items here.':
    '{ref} — der Inhalt, auf dem dieses Arbeitsergebnis in {other} aufbaut, hat sich geändert. Gleiche mit {other} ab und schlage hier Anpassungen an meinen Inhaltselementen vor.',
}, 'RoadmapView');
